import { computed, toRef } from 'vue'

export default function useConditionalSpacing(
  prevComponent,
  nextComponent,
  inlineComponents = [],
) {
  const prevComponentRef = toRef(prevComponent, 'value')
  const nextComponentRef = toRef(nextComponent, 'value')

  return computed(() => {
    if (!inlineComponents.length) {
      inlineComponents = ['br_text', 'br_image', 'br_table', 'br_line_chart', 'text', 'text_highlighted', 'image', 'video', 'image_with_text', 'table', 'accordion']
    }

    // if the PREVIOUS and NEXT component are both inline components
    if (
      inlineComponents.includes(prevComponentRef.value)
      && inlineComponents.includes(nextComponentRef.value)
    ) {
      return 'py-4 sm:py-8'
    }

    // if the PREVIOUS component is an inline component
    if (inlineComponents.includes(prevComponentRef.value)) {
      return 'pb-14 sm:pb-24 pt-4 sm:pt-8'
    }

    // if the NEXT component is an inline component
    if (inlineComponents.includes(nextComponentRef.value)) {
      return 'pt-14 sm:pt-24 pb-8 sm:pb-8'
    }

    return 'py-14 sm:py-24'
  })
}
